import React from 'react';
import { Radio, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import useExport from '@components/export/useExport';
import { track } from '@utils';
import { CLICK_EXPORT_RESILIENCY_TABLE } from '@src/utils/sensor/track';

export const exportConfig = {
  page: { key: 'precision', title: 'Precision Dashboard' },
  sections: [
    { key: 'resiliency', title: 'Avoidance Specifics' },
    {
      key: 'impact-avoidance-breakdown',
      title: 'CDN Resources & ISP - Impact Avoidance Breakdown',
    },
  ],
};

function ExportTable() {
  const { triggerDownload } = useExport({ config: exportConfig });

  const handleClickExport = () => {
    track({ event: CLICK_EXPORT_RESILIENCY_TABLE });
    triggerDownload();
  };

  return (
    <Radio.Button onClick={handleClickExport}>
      <Tooltip title="Export">
        <DownloadOutlined style={{ fontSize: 16 }} />
      </Tooltip>
    </Radio.Button>
  );
}

export default ExportTable;
